import { render } from "./Pedido.vue?vue&type=template&id=212ab208&scoped=true"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"

import "./Pedido.vue?vue&type=style&index=0&id=212ab208&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212ab208"]])

export default __exports__